import PhoneInput, {
  DefaultInputComponentProps,
} from "react-phone-number-input";

import "react-phone-number-input/style.css";

import { ErrorMessage } from "../ErrorMessage";
import { Container, Content } from "./styles";

const Phone = ({
  value,
  onChange,
  defaultCountry,
  error,
  ...rest
}: DefaultInputComponentProps) => {
  return (
    <Container>
      <Content>
        <PhoneInput
          {...rest}
          value={value}
          onChange={onChange}
          defaultCountry={defaultCountry}
        />
      </Content>
      {error && <ErrorMessage erro={error} />}
    </Container>
  );
};

export { Phone };
